import React from 'react';
// images
import quizCalloutImage from  '../../../../../images/components/experienceCalloutImages/couple-looking-at-a-laptop.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    // configs
    sectionId='quiz-callout-investment-advisory-services'
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
    moduleVariation='A'
    moduleName='quiz-callout-module'
    withBGImage
    isFullWidth
    disableLazyLoad
    // content
    imageUrl={quizCalloutImage}
    headingText='How much do you know about investing and your finances&#63;'
    assistiveText='Take our Investing and Finances quiz.'
    buttonText='Take our quiz'
    linkUrl='/life-and-money/quiz/how-much-do-you-know-about-investing-and-your-finances/'
    ariaLabel='Take our investing and finances quiz.'
  />
);
